import {
    NEW_PROPRIEDADE_CADASTRO_SUCCESS,
    TABLE_PROPRIEDADE_CADASTRO_PENDING,
    TABLE_PROPRIEDADE_CADASTRO_SUCCESS,
    TABLE_PROPRIEDADE_CADASTRO_FAILURE,
    LIST_PROPRIEDADE_CADASTRO_PENDING,
    LIST_PROPRIEDADE_CADASTRO_SUCCESS,
    LIST_PROPRIEDADE_CADASTRO_FAILURE,
    FIND_PROPRIEDADE_CADASTRO_PENDING,
    FIND_PROPRIEDADE_CADASTRO_SUCCESS,
    FIND_PROPRIEDADE_CADASTRO_FAILURE,
    DELETE_PROPRIEDADE_CADASTRO_PENDING,
    DELETE_PROPRIEDADE_CADASTRO_SUCCESS,
    DELETE_PROPRIEDADE_CADASTRO_FAILURE,
    CREATE_PROPRIEDADE_CADASTRO_PENDING,
    CREATE_PROPRIEDADE_CADASTRO_SUCCESS,
    CREATE_PROPRIEDADE_CADASTRO_FAILURE,
} from './actionTypes';


const initialState = { list: null, loading: false }


function propriedadeCadastroReducer(state = initialState, action) {

    switch (action.type) {
        case NEW_PROPRIEDADE_CADASTRO_SUCCESS:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case LIST_PROPRIEDADE_CADASTRO_PENDING:
        case FIND_PROPRIEDADE_CADASTRO_PENDING:
        case DELETE_PROPRIEDADE_CADASTRO_PENDING:
        case CREATE_PROPRIEDADE_CADASTRO_PENDING:
        case TABLE_PROPRIEDADE_CADASTRO_PENDING:
            return {
                ...state,
                loading: true,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case LIST_PROPRIEDADE_CADASTRO_SUCCESS:
            return {
                ...state,
                list: action.list,
                loading: false
            }
        case LIST_PROPRIEDADE_CADASTRO_FAILURE:
            return {
                ...state,
                list: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case TABLE_PROPRIEDADE_CADASTRO_SUCCESS:
            return {
                ...state,
                table: action.table,
                loading: false
            }
        case TABLE_PROPRIEDADE_CADASTRO_FAILURE:
            return {
                ...state,
                table: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case FIND_PROPRIEDADE_CADASTRO_SUCCESS:
            return {
                ...state,
                registro: action.registro,
                loading: false
            }
        case FIND_PROPRIEDADE_CADASTRO_FAILURE:
            return {
                ...state,
                registro: null,
                loading: false
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case DELETE_PROPRIEDADE_CADASTRO_SUCCESS: {
            return {
                ...state,
                loading: false
            }
        }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        case CREATE_PROPRIEDADE_CADASTRO_SUCCESS:
        case CREATE_PROPRIEDADE_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
                registro: action.registro
            }
        case DELETE_PROPRIEDADE_CADASTRO_FAILURE:
            return {
                ...state,
                loading: false,
            }
        // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
        default:
            return state
    }
}

export { propriedadeCadastroReducer };